import React from "react";

const CardSmall = (props) => {
    const { img, title, textDes, imgLink1, imgLink2 } = props.item;
    return (
        <div className="support__item">
            <div className="row center">
                <div className="col l-5 m-12 c-12">
                    <div className="support__img">
                        <img src={img} alt="support - 22 Pushups" />
                    </div>
                </div>
                <div className="col l-7 m-12 c-12">
                    <div className="support__textBox">
                        <h4 className="textBox__title--mid">{title}</h4>
                        <p className="textBox__text">{textDes}</p>
                        <div>
                            <a
                                href={imgLink1.href}
                                target="_blank"
                                rel="noreferrer"
                            >
                                <img src={imgLink1.img} alt="appStore" />
                            </a>

                            {imgLink2 && (
                                <a
                                    href={imgLink2.href}
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    <img src={imgLink2.img} alt="appStore" />
                                </a>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CardSmall;
